module.exports = [
    {
        "number": 1,
        "question": "Does your family like to congregate or do their own thing?",
        "params": "squareFoot",
        "bgColor": "#97c93c",
        "choices": [
            {
                "number": 1,
                "description": "We spend a lot of time together.",
                "value": "maxSquareFeet=1500&minSquareFeet=0"
            },
            {
                "number": 2,
                "description": "Mix of alone time and together time.",
                "value": "maxSquareFeet=2500&minSquareFeet=1000"
            },
            {
                "number": 3,
                "description": "We like our space.",
                "value": "maxSquareFeet=4000&minSquareFeet=1000"
            }
        ],
        "isLast": false
    },
    {
        "number": 2,
        "question": "How many people will be living under your new roof?",
        "params": "bedsBaths",
        "bgColor": "#4f9e44",
        "choices": [
            {
                "number": 1,
                "description": "Just me.",
                "value": "beds=1&baths=1"
            },
            {
                "number": 2,
                "description": "Just the two of us.",
                "value": "beds=1&baths=1"
            },
            {
                "number": 3,
                "description": "Just us plus one.",
                "value": "beds=2&baths=1"
            },
            {
                "number": 4,
                "description": "The kids are starting to outnumber us.",
                "value": "beds=3&baths=2"
            },
        ],
        "isLast": false
    },
    {
        "number": 3,
        "question": "Do you have a lot of land or a little? ",
        "params": "multiSection",
        "bgColor": "#97d4ca",
        "choices": [
            {
                "number": 1,
                "description": "Not another home around for miles.",
                "value": "true"
            },
            {
                "number": 2,
                "description": "We have some neighbors, but they’re pretty spread out.",
                "value": "true"
            },
            {
                "number": 3,
                "description": "We could high five our neighbors from the kitchen window.",
                "value": "false"
            },
            {
                "number": 4,
                "description": "We haven’t gotten that far yet.",
                "value": "null"
            },
        ],
        "isLast": false
    },
    {
        "number": 4,
        "question": "From zero to tycoon, how much do you have to spend?",
        "params": "priceRange",
        "bgColor": "#00b0ac",
        "choices": [
            {
                "number": 1,
                "description": "Need a lot for a little.",
                "value": "maxPrice=50000&minPrice=0"
            },
            {
                "number": 2,
                "description": "$45,000 – $80,000",
                "value": "maxPrice=80000&minPrice=45000"
            },
            {
                "number": 3,
                "description": "$80,000 – $120,000",
                "value": "maxPrice=120000&minPrice=80000"
            },
            {
                "number": 4,
                "description": "If we love it, money is not an issue.",
                "value": "maxPrice=275000&minPrice=75000"
            },
        ],
        "isLast": false
    },
    {
        "number": 5,
        "question": "Are you more of a Great Dane or a goldfish kind of family?",
        "params": "squareFoot",
        "bgColor": "#0076bb",
        "choices": [
            {
                "number": 1,
                "description": "Dogs all the way.",
                "value": "250"
            },
            {
                "number": 2,
                "description": "Cats rule, dogs drool.",
                "value": "0"
            },
            {
                "number": 3,
                "description": "All of our pets can fit on a shelf.",
                "value": "0"
            },
            {
                "number": 4,
                "description": "We’re a human-only household.",
                "value": "0"
            },
        ],
        "isLast": true
    },
]